import {
  Col,
  DatePicker,
  Form,
  Grid,
  Input,
  message,
  Row,
  Select,
  TimePicker,
} from "antd";
import { Modal } from "components";
import dayjs from "dayjs";
import { DiscountApiService } from "features/discount-code/api/discount-api.service";
import { useCreateDiscountCode } from "features/discount-code/use-cases/create-discount-code";
import { useEffect, useState } from "react";
// import { getDisabledMinutes } from "utils/date";

const { useBreakpoint } = Grid;

export const EditDiscountCodeModal = ({ onClose, id, onSuccess }: any) => {
  const formName = "edit-discount-form";
  const screens = useBreakpoint();
  const [validateTrigger, setValidateTrigger] = useState(["onSubmit"]);
  const [form] = Form.useForm();
  const [isUser, setIsUsed] = useState<any>(null);
  const [paymenttypeDrop, setPaymentMethod] = useState<any[]>([]);

  const [sportsData, setSportsData] = useState<any>(null);
  const [facilityData, setFacilityData] = useState<any>(null);
  const [packagesData, setPackagesData] = useState<any>(null);
  const [couponType, setCouponType] = useState<any>(null);
  const [redirectVal, setRedirectVal] = useState<any>(null);

  // --- API Fetchers ---

  const getSportsData = async (redValue: string) => {
    try {
      const apiRes = await DiscountApiService().getDiscountDropDown({
        Flag: redValue === "Booking" ? "BookingSports" : "PackageSports",
      } as any);
      setSportsData(apiRes);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const getDiscountPaymentMethodData = async () => {
    try {
      const apiRes = await DiscountApiService().getDiscountDropDownPaymentList(
        "" as any
      );
      setPaymentMethod(apiRes);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const getFacilityData = async (redirectLabel: string, sportsId: string) => {
    try {
      const apiRes = await DiscountApiService().getDiscountDropDown({
        Flag:
          redirectLabel === "Booking" || redirectLabel === "FixedBooking"
            ? "BookingFacility"
            : "PackageFacility",
        sport_id: sportsId,
      } as any);
      setFacilityData(apiRes);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  // Fixed: Accepts currentRedirect to avoid stale state issues on first load
  const getPackagesOrFieldsData = async (
    facilityId: string,
    currentRedirect?: string
  ) => {
    try {
      const activeRedirect = currentRedirect || redirectVal;
      const isBooking =
        activeRedirect === "Booking" || activeRedirect === "FixedBooking";

      const apiRes = await DiscountApiService().getDiscountDropDown({
        Flag: isBooking ? "FacilityWiseField" : "FacilityWisePackage",
        facility_id: facilityId,
      } as any);

      setPackagesData(apiRes);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const intialsDeatils = async () => {
    try {
      const apiRes = await DiscountApiService().getDiscountDetails({
        id,
      } as any);
      const data = apiRes.items[0];

      const { SlotStartTime, SlotEndTime, CouponFor, SportId, FacilityId } =
        data;

      // Update State
      setRedirectVal(CouponFor);
      setCouponType(data.DiscountTypeId);
      setIsUsed(data.TotalUsedCoupon);

      // Set Form Values
      form.setFieldsValue({
        Title: data.Title,
        NoOfCoupons: data.NoOfCoupons,
        StartDate: data.StartDate && dayjs(data.StartDate),
        EndDate: data.EndDate && dayjs(data.EndDate),
        DiscountTypeId: data.DiscountTypeId,
        DiscountValue: data.DiscountValue,
        CouponFor: CouponFor,
        PackageId: data.PackageId,
        SportId: SportId,
        FacilityId: FacilityId,
        FieldId: data.FieldId,
        ItemId: SlotStartTime &&
          SlotEndTime && [
            dayjs(SlotStartTime, "HH:mm"),
            dayjs(SlotEndTime, "HH:mm"),
          ],
        PaymentType: data.PaymentType,
      });

      // Chain API calls using variables directly (to ensure "isBooking" logic works first time)
      getSportsData(CouponFor);
      getFacilityData(CouponFor, SportId);
      getPackagesOrFieldsData(FacilityId, CouponFor);
    } catch (error: any) {
      message.error(error?.message || "Failed to fetch details");
    }
  };

  // --- Handlers ---

  const { isLoading, mutate } = useCreateDiscountCode();

  const handleUpdate = async (formData: any) => {
    const updatedFormData = {
      ...formData,
      id: id,
      DiscountType: formData.DiscountTypeId === 1 ? "Flat" : "Percent",
      SlotStartTime:
        formData.ItemId && dayjs(formData.ItemId[0]).format("HH:mm"),
      SlotEndTime: formData.ItemId && dayjs(formData.ItemId[1]).format("HH:mm"),
      StartDate: dayjs(formData.StartDate).format("YYYY-MM-DD"),
      EndDate: dayjs(formData.EndDate).format("YYYY-MM-DD"),
      NoOfCoupons: +formData.NoOfCoupons,
      DiscountValue: +formData.DiscountValue,
    };
    delete updatedFormData.ItemId;

    mutate(updatedFormData, {
      onSuccess: (data: any) => {
        if (data.ResponseStatus === 1) onSuccess();
      },
    });
  };

  useEffect(() => {
    intialsDeatils();
    getDiscountPaymentMethodData();
  }, [id]);

  const handleRedirectionChange = (value: string) => {
    setRedirectVal(value);
    getSportsData(value);
    form.resetFields([
      "SportId",
      "FacilityId",
      "ItemId",
      "FieldId",
      "PackageId",
    ]);
  };

  const handleSportsChange = (value: string) => {
    getFacilityData(redirectVal, value);
    form.resetFields(["FacilityId", "FieldId", "PackageId"]);
  };

  const handleFacilityChange = (value: string) => {
    getPackagesOrFieldsData(value);
    form.resetFields(["PackageId", "FieldId"]);
  };

  // --- Input Validation Helpers ---

  const handleKeyValueDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const allowedKeys = [
      "Backspace",
      "Tab",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      ".",
      "Enter",
    ];
    const isNumber = /^[0-9]$/;
    if (!allowedKeys.includes(e.key) && !isNumber.test(e.key))
      e.preventDefault();
    if (
      e.key === "." &&
      (e.currentTarget.value.includes(".") || e.currentTarget.value === "")
    )
      e.preventDefault();
  };

  // const handleKeyCouponDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //   const allowedKeys = [
  //     "Backspace",
  //     "Tab",
  //     "Delete",
  //     "ArrowLeft",
  //     "ArrowRight",
  //     "Enter",
  //   ];
  //   if (!allowedKeys.includes(e.key) && !/^[0-9]$/.test(e.key))
  //     e.preventDefault();
  // };

  return (
    <Modal
      open
      centered
      className="right-modal cstmmdlright"
      title="Edit Discount Code"
      onCancel={onClose}
      getContainer={false}
      onOk={!isUser ? form.submit : undefined}
      okButtonProps={{ loading: isLoading, disabled: !!isUser }}
      okText={!isUser ? "Update" : "OK"}
      cancelButtonProps={{ style: { display: "none" } }}
      width={screens.lg ? "520px" : "100%"}
    >
      <figure style={{ padding: "15px 5px" }}>
        <Form
          id={formName}
          form={form}
          layout="vertical"
          onFinish={handleUpdate}
          onFinishFailed={() => setValidateTrigger(["onChange"])}
          validateTrigger={validateTrigger}
          disabled={isLoading || !!isUser}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Name"
                name="Title"
                rules={[{ required: true, message: "Please enter name" }]}
              >
                <Input placeholder="Enter your name" maxLength={54} />
              </Form.Item>
            </Col>
            {/* <Col span={12}>
              <Form.Item
                label="Limit Usage"
                name="NoOfCoupons"
                rules={[
                  { required: true, message: "Please enter Limit Usage" },
                ]}
              >
                <Input
                  placeholder="Limit Usage"
                  onKeyDown={handleKeyCouponDown}
                  maxLength={5}
                />
              </Form.Item>
            </Col> */}
            <Col span={12}>
              <Form.Item
                label="From Date"
                name="StartDate"
                rules={[{ required: true, message: "Please enter From Date" }]}
              >
                <DatePicker
                  format="DD-MM-YYYY"
                  disabledDate={(current) =>
                    current && current.isBefore(dayjs().startOf("day"))
                  }
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="To Date"
                name="EndDate"
                rules={[
                  { required: true, message: "Select To Date" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const start = getFieldValue("StartDate");
                      if (
                        !value ||
                        !start ||
                        value.isAfter(start) ||
                        value.isSame(start, "day")
                      )
                        return Promise.resolve();

                      return Promise.reject(
                        new Error("End Date must be >= Start Date")
                      );
                    },
                  }),
                ]}
              >
                <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Type of Coupon"
                name="DiscountTypeId"
                rules={[{ required: true, message: "Select Type" }]}
              >
                <Select
                  options={[
                    { value: 1, label: "Flat" },
                    { value: 2, label: "Percent" },
                  ]}
                  onChange={(val) => {
                    setCouponType(val);
                    form.resetFields(["DiscountValue"]);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Value"
                name="DiscountValue"
                rules={[{ required: true, message: "Enter value" }]}
              >
                <Input
                  addonAfter={couponType === 2 ? "%" : null}
                  onKeyDown={handleKeyValueDown}
                  onChange={(e) => {
                    if (couponType === 2 && parseFloat(e.target.value) > 100)
                      form.setFieldValue("DiscountValue", "100");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Coupon For"
                name="CouponFor"
                rules={[{ required: true, message: "Select Coupon For" }]}
              >
                <Select
                  options={[
                    { value: "Booking", label: "Booking" },
                    { value: "Package", label: "Package" },
                    { value: "FixedBooking", label: "Fixed Booking" },
                  ]}
                  onChange={handleRedirectionChange}
                />
              </Form.Item>
            </Col>

            {/* Conditional Fields */}
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const couponFor = getFieldValue("CouponFor");
                const sportId = getFieldValue("SportId");
                const facilityId = getFieldValue("FacilityId");
                const fieldId = getFieldValue("FieldId");

                return (
                  <>
                    {couponFor === "FixedBooking" && (
                      <Col span={12}>
                        <Form.Item
                          label="Payment Method"
                          name="PaymentType"
                          rules={[{ required: true }]}
                        >
                          <Select
                            options={paymenttypeDrop?.map((i) => ({
                              label: i.type,
                              value: i.id,
                            }))}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    {couponFor && (
                      <Col span={12}>
                        <Form.Item label="Sports" name="SportId">
                          <Select
                            showSearch // Enable search functionality
                            placeholder="Please select Sports"
                            options={sportsData?.items.map((i: any) => ({
                              label: i.name,
                              value: i.id,
                            }))}
                            filterOption={(input, option) =>
                              typeof option?.label === "string" &&
                              option.label
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={handleSportsChange}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    {sportId && (
                      <Col span={12}>
                        <Form.Item label="Facility" name="FacilityId">
                          <Select
                            showSearch // Enable search functionality
                            options={facilityData?.items.map((i: any) => ({
                              label: i.name,
                              value: i.id,
                            }))}
                            filterOption={(input, option) =>
                              typeof option?.label === "string" &&
                              option.label
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={handleFacilityChange}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    {facilityId && (
                      <Col span={12}>
                        <Form.Item
                          label={couponFor === "Package" ? "Package" : "Fields"}
                          name={
                            couponFor === "Package" ? "PackageId" : "FieldId"
                          }
                        >
                          <Select
                            showSearch
                            options={packagesData?.items.map((i: any) => ({
                              label: i.name,
                              value: i.id,
                            }))}
                            filterOption={(input, option) =>
                              typeof option?.label === "string" &&
                              option.label
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </Form.Item>
                      </Col>
                    )}
                    {(couponFor === "Booking" ||
                      couponFor === "FixedBooking") &&
                      fieldId && (
                        <Col span={12}>
                          <Form.Item label="Slots" name="ItemId">
                            <TimePicker.RangePicker
                              format="h mm A"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                  </>
                );
              }}
            </Form.Item>
          </Row>
        </Form>
      </figure>
    </Modal>
  );
};
